
export default function WhyHealth() {
  const reasons = [
    {
      icon: 'ri-heart-pulse-line',
      text: 'Health is not optional, it\'s always in demand',
    },
    {
      icon: 'ri-leaf-line',
      text: 'Natural solutions, real problems',
    },
    {
      icon: 'ri-calendar-line',
      text: 'Non-seasonal business',
    },
    {
      icon: 'ri-hand-heart-line',
      text: 'Earn while creating impact',
    },
  ];

  return (
    <section className="py-20 bg-stone-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Why Health?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 flex items-center hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-stone-200"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-full flex-shrink-0">
                <i className={`${reason.icon} text-white text-2xl`}></i>
              </div>
              <p className="text-gray-700 ml-6 text-base sm:text-lg font-medium">
                {reason.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
